import { IEnhancedTeamStats, ITeamDetails, TeamID, UID } from '@shared/types';
import { DivisionalTeamData } from 'app/scenes/statsmanager/components/standings/components/division/Division';
import {
  IGame,
  IMatchup,
  IRanking,
  ITeamsOnByeWeek,
  ITeamStandings,
  ITeamWeeklyResult,
  ITeamWeekRank,
  RankingsPayload,
} from 'types';
import { toNumber } from './IdHelpers';

export const sortWeeklyGamesByDateTime = (a: IGame | IMatchup, b: IGame | IMatchup) => {
  return parseFloat(a.gameTime_epoch) - parseFloat(b.gameTime_epoch);
};

export const sortTeamsByValue = (a: IRanking, b: IRanking) => {
  return a.value - b.value;
};

export const sortTeamWeeklyResultByTeamID = (a: ITeamWeeklyResult, b: ITeamWeeklyResult) => {
  return sortByTeamID(a.teamID, b.teamID);
};

export const sortByTeamID = (a: TeamID, b: TeamID) => parseInt(a) - parseInt(b);

export const sortByUID = (a: UID, b: UID) => {
  return a < b ? -1 : a > b ? 1 : 0;
};

export const sortByOrderedUID = (a: ITeamStandings | IEnhancedTeamStats, b: ITeamStandings | IEnhancedTeamStats) => {
  return a.uID < b.uID ? -1 : a.uID > b.uID ? 1 : 0;
};

export const sortByStandingsUID = (a: ITeamStandings | IEnhancedTeamStats, b: ITeamStandings | IEnhancedTeamStats) => {
  return a.uID < b.uID ? -1 : a.uID > b.uID ? 1 : 0;
};

export const sortWeekRankByWeekID = (a: RankingsPayload, b: RankingsPayload) => {
  return toNumber(a.weekID) - toNumber(b.weekID);
};

export const sortTeamDetailsByTeamID = (a: ITeamDetails, b: ITeamDetails) => {
  return parseInt(a.teamID) - parseInt(b.teamID);
};

export const sortTeamMatchupsByGameID = (a: IMatchup, b: IMatchup) => a.gameID.localeCompare(b.gameID);

export const sortByWeekID = (a: ITeamsOnByeWeek, b: ITeamsOnByeWeek) => {
  return toNumber(a.weekID) - toNumber(b.weekID);
};

export const sortDivisionalTeamsByPct = (a: DivisionalTeamData, b: DivisionalTeamData) => {
  const valuePct = b.teamWeeklyResult.pct * 10 - a.teamWeeklyResult.pct * 10;
  const valuePF = b.teamWeeklyResult.pf - a.teamWeeklyResult.pf;
  const valueWins = b.teamWeeklyResult.wins - a.teamWeeklyResult.wins;
  const valuePA = a.teamWeeklyResult.pa - b.teamWeeklyResult.pa;
  const valueLosses = a.teamWeeklyResult.losses - b.teamWeeklyResult.losses;
  const valueHomeRec =
    parseInt(b.teamWeeklyResult.homeRecord.replace('-', '')) - parseInt(a.teamWeeklyResult.homeRecord.replace('-', ''));

  const isPctEqual = valuePct === 0;
  const isPFEqual = valuePF === 0;
  const isWinsEqual = valueWins === 0;
  const isLossesEqual = valueLosses === 0;
  const isHomeRecEqual = valueHomeRec === 0;

  return isPctEqual
    ? isWinsEqual
      ? isLossesEqual
        ? isHomeRecEqual
          ? isPFEqual
            ? valuePA
            : valuePF
          : valueHomeRec
        : valueLosses
      : valueWins
    : valuePct;
};

export const sortTeamsByCompletionPct = (a: ITeamWeekRank, b: ITeamWeekRank) => {
  if (a.isByeWeek && b.isByeWeek) return 0;
  if (!a.isByeWeek && b.isByeWeek) return 1;
  if (a.isByeWeek && !b.isByeWeek) return -1;
  return b.value - a.value;
};
